const LoadingSpinner = () => {
  return (
    <div className='absolute inset-0 flex justify-center items-center bg-background/70 dark:bg-background-dark/70 backdrop-blur-sm z-[1000] theme-transition'>
      <div className='w-[50px] h-[50px] border-4 border-gray-200 !border-t-blue-500 rounded-full animate-spin'></div>
    </div>
  );
};

export default LoadingSpinner;
